var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-integrations__description has-text-centered" },
      [_vm._v("\n    " + _vm._s(_vm.app.subtitle) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "sc-tooltip",
          {
            staticClass: "tooltip",
            attrs: {
              label:
                _vm.app.status === "MANUALLY_INSTALLED"
                  ? "Você já possui essa transportadora instalada! Veja em Minhas Transportadoras"
                  : "",
              multilined: ""
            }
          },
          [
            ["UNINSTALLED", "INSTALL_FAILED"].includes(_vm.app.status)
              ? _c("sc-button", {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "install-btn-" + _vm.app.id,
                    theme: "primary",
                    text: "Instalar",
                    disabled: _vm.loading
                  },
                  on: {
                    click: function() {
                      return _vm.handleStepClick(_vm.app)
                    }
                  }
                })
              : _vm.app.editable && _vm.app.status === "INSTALLED"
              ? _c("sc-button", {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "installed-btn-" + _vm.app.id,
                    theme: "secondary",
                    outlined: "true",
                    icon: "pen",
                    text: "Editar"
                  }
                })
              : _c("sc-button", {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "installed-btn-" + _vm.app.id,
                    theme: "success",
                    icon: "check-circle",
                    text: "Instalado"
                  }
                })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd5984a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd5984a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/app-card/body-card/BodyCard.vue
// module id = null
// module chunks = 